import React from 'react'
import styled from "styled-components"

const Check = styled.input`
`

const CheckBox = ({name = "", onChange = null, id = null}) => {
    return <Check type="checkbox" id={id} name={name} onChange={onChange}/>
}

export default CheckBox
